import React, { useState } from 'react';
import { FaPizzaSlice } from 'react-icons/fa';
import { 
    FiCloudLightning,
    FiPlus,
    FiPlusSquare
 } from 'react-icons/fi';
import { AddTask } from '../AddTasks';

export const Header = ({ darkMode, setDarkMode }) => {
    const [shouldShowMain, setShouldShowMain] = useState(false);
    const [showQuickAddTask, setShowQuickAddTask] = useState(false);

    return (
        <header className="header" data-testid="header">
            <nav>
                <div className="logo">
                    <img src="/images/logo.png" alt="Toodle"/>
                </div>
                <div className="settings">
                    <ul>
                        <li className="settings__add">
                            <button
                                data-testid="quick-add-task-action"
                                type="button"
                                onClick={() => {
                                    setShowQuickAddTask(true);
                                    setShouldShowMain(true);
                                }}
                            >
                                <FiPlus />
                            </button>
                        </li>
                        <li className="settings__darkmode">
                            <button
                                data-testid="dark-mode-action"
                                type="button"
                                onClick={() => setDarkMode(!darkMode)}
                            >
                               <FiCloudLightning /> 
                            </button>
                            
                        </li>
                    </ul> 
                </div>
            </nav>

            <AddTask
                showAddTaskMain={false}
                shouldShowMain={shouldShowMain}
                showQuickAddTask={showQuickAddTask}
                setShowQuickAddTask={setShowQuickAddTask}
            />
        </header>
)};
